module.exports = __webpack_public_path__ + "Roboto-BoldItalic.355e388740673054493c.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff2
// module id = 136
// module chunks = 10